// extracted by mini-css-extract-plugin
export default {"component":"ErrorBox_component__E9Zki"};